/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import Select from "react-select";
import { withTranslation } from "react-i18next";
import { Button, Card } from "react-bootstrap";
import { language } from "../../../../../languages/language";
import { useDispatch, useSelector } from "react-redux";
import * as actions from "../../../../../store/actions/index";
import * as campaignActions from "../../../../../store/actions/createCampaign/createCampaignAction";
import { getMeta } from "../../../../../store/actions/meta/metaActions";
import { setCookie } from "../../../../../helpers/cookieHelper";
import { getLanguageCode, getLanguageId } from "../../../../../helpers";
import classNames from "classnames";
import "../Footer.scss";

function ChangeLanguage(props) {
  const dispatch = useDispatch();

  const [selectedLanguage, setSelectedLanguage] = useState("ar");
  
  useEffect(() => {
    dispatch(actions.getLanguages());
    dispatch(actions.getMenuItem("header", "footer", "socialMedia"));
    dispatch(actions.getTaxonomy());
  }, [dispatch]);

  const { i18n } = props;
  const { languages, defaultLang, currentLang } = useSelector(
    (state) => state.languages
  );

  const currentLng = getLanguageCode();
  let defaultLanguage = defaultLang;
  
  /**
   * languages from API filtered
   */
  let lang = languages.map(({ name: label, folder: value, ...rest }) => ({
    label,
    value,
    ...rest,
  }));


  lang
    .filter((item) => item.value === localStorage.getItem("i18nextLng"))
    .map((item) => {
      return (defaultLanguage = item);
    });

  useEffect(() => {
    if (!languages?.length) return;
    const currentLng = getLanguageId();
    if (!currentLng) return;

    const timer = setTimeout(() => {
      const matchingLang = lang?.find((item) => item?.value === currentLng);
      if (matchingLang) {
        setSelectedLanguage(matchingLang);
      }
    }, 1000);

    return () => clearTimeout(timer);
  }, [languages, lang]);

  const changeLanguage = (language) => {
    i18n.changeLanguage(language.value);
    dispatch(actions.getSliders(language.id));
    dispatch(
      actions.getMenuItem("header", "footer", "socialMedia", language.id)
    );
    dispatch(campaignActions.getCategories(language.id));
    dispatch(campaignActions.getIndustries(language.id));
    dispatch(campaignActions.getTeamMemberType(language.id));
    dispatch(campaignActions.getCampaignStage(language.id));
    dispatch(campaignActions.getInvestingRound(language.id));
    dispatch(campaignActions.getInvestor(language.id));

    localStorage.setItem("i18nextLng", language.value);
    setCookie("i18next", language.value);
    if (localStorage.getItem("selected_language_id") !== language.id) {
      localStorage.setItem("selected_language_id", language.id);
      dispatch(getMeta(localStorage.getItem("selected_language_id")));
      window.location.reload();
    }
  };

  return (
    <Card.Body className="d-flex justify-content-end gap-2">
      {/* <Select
        isSearchable={false}
        value={selectedLanguage}
        onChange={changeLanguage}
        options={lang}
        inputId={lang.id}
        classNamePrefix="react-select"
        className={classNames("react-select-container change-language ")}
        menuPlacement="auto"
      /> */}

      {lang.map((item, index) => {
        return (
          <Button
            key={index}
            onClick={() => {
              changeLanguage(item);
            }}
            className={classNames(
              "change-language-btn square-btn ",
              item.value === currentLng ? "change-language-btn-active" : ""
            )}
          >
            {item.value.charAt(0).toUpperCase() + item.value.slice(1)}
          </Button>
        );
      })}
    </Card.Body>
  );
}

export default withTranslation()(ChangeLanguage);
